<select #input  class="w-100" [(ngModel)]="params.value" (ngModelChange)="changeValue($event)">
  <option *ngIf="unlinkValue" disabled selected [ngValue]="params.value">*{{params.value}}*</option>
  <option *ngFor="let param of params?.param" [ngValue]="param.id">{{param.value}} </option>
</select>
